import { SweetAlertResult } from "sweetalert2";
import { DialogService } from "@/service/DialogService";
import { WritableComputedRef } from "vue";

export function useTableRow() {
    const addRow = (rows: WritableComputedRef<any>, defaultValue: any = {}) => {
        if (!rows.value) {
            rows.value = [];
        }
        rows.value.push(defaultValue);
    };

    const addRowNoRef = (rows?: any, defaultValue: any = {}) => {
        if (!rows) {
            rows = [];
        }
        rows.push(defaultValue);
    };

    const removeTableRow = async (row: any, index:number, message?: string) => {
        await DialogService.question({
            text: message ? message : "指定された行を削除しますか？",
            showCancelButton: true,
            confirmButtonText: "削除します",
            cancelButtonText: "キャンセル",
        }).then((result: SweetAlertResult) => {
            if (result.isConfirmed) {
                row.splice(index, 1)
            }
        });
    };

    return {
        addRow,
        addRowNoRef,
        removeTableRow,
    };
}
